import { render, staticRenderFns } from "./relatorios.vue?vue&type=template&id=44dfa786&scoped=true&"
import script from "./relatorios.vue?vue&type=script&lang=js&"
export * from "./relatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dfa786",
  null
  
)

export default component.exports